import type { Directive } from "vue";

export const vMario: Directive<HTMLCanvasElement & { _resize: () => void }> = {
	mounted(mc) {
		const mctx = mc.getContext("2d")!;
		mc._resize = () => {
			mc.width = window.innerWidth;
			mc.height = window.innerHeight;
		};
		mc._resize();
		window.addEventListener("resize", mc._resize);

		const S = 4;
		const _ = null;
		const R = "#E52222";
		const T = "#fed1b0";
		const B = "#1a1aff";
		const W = "#222";
		const Y = "#E8B84B";

		const marioF0 = [
			[_, _, _, R, R, R, R, R, _, _, _, _, _, _, _, _],
			[_, _, R, R, R, R, R, R, R, R, R, _, _, _, _, _],
			[_, _, W, W, W, T, T, W, T, _, _, _, _, _, _, _],
			[_, W, T, W, T, T, T, W, T, T, T, _, _, _, _, _],
			[_, W, T, W, W, T, T, T, W, T, T, T, _, _, _, _],
			[_, W, W, T, T, T, T, W, W, W, W, _, _, _, _, _],
			[_, _, _, T, T, T, T, T, T, T, _, _, _, _, _, _],
			[_, _, B, B, R, B, B, B, _, _, _, _, _, _, _, _],
			[_, B, B, B, R, B, B, B, B, B, _, _, _, _, _, _],
			[B, B, B, B, R, R, B, B, B, B, B, _, _, _, _, _],
			[T, T, B, R, Y, R, R, Y, B, T, T, _, _, _, _, _],
			[T, T, T, R, R, R, R, R, T, T, T, _, _, _, _, _],
			[T, T, R, R, R, R, R, R, R, T, T, _, _, _, _, _],
			[_, _, R, R, R, _, _, R, R, R, _, _, _, _, _, _],
			[_, W, W, W, _, _, _, W, W, W, _, _, _, _, _, _],
			[W, W, W, W, _, _, W, W, W, W, _, _, _, _, _, _],
		];

		const marioF1 = [
			[_, _, _, R, R, R, R, R, _, _, _, _, _, _, _, _],
			[_, _, R, R, R, R, R, R, R, R, R, _, _, _, _, _],
			[_, _, W, W, W, T, T, W, T, _, _, _, _, _, _, _],
			[_, W, T, W, T, T, T, W, T, T, T, _, _, _, _, _],
			[_, W, T, W, W, T, T, T, W, T, T, T, _, _, _, _],
			[_, W, W, T, T, T, T, W, W, W, W, _, _, _, _, _],
			[_, _, _, T, T, T, T, T, T, T, _, _, _, _, _, _],
			[_, _, B, B, R, B, B, B, _, _, _, _, _, _, _, _],
			[_, B, B, B, R, B, B, B, B, B, _, _, _, _, _, _],
			[B, B, B, B, R, R, B, B, B, B, B, _, _, _, _, _],
			[T, T, B, R, Y, R, R, Y, B, T, T, _, _, _, _, _],
			[T, T, T, R, R, R, R, R, T, T, T, _, _, _, _, _],
			[T, T, R, R, R, R, R, R, R, T, T, _, _, _, _, _],
			[_, R, R, R, _, _, _, _, R, R, R, _, _, _, _, _],
			[W, W, W, _, _, _, _, _, W, W, W, _, _, _, _, _],
			[W, W, _, _, _, _, _, _, _, W, W, _, _, _, _, _],
		];

		const marioF2 = [
			[_, _, _, R, R, R, R, R, _, _, _, _, _, _, _, _],
			[_, _, R, R, R, R, R, R, R, R, R, _, _, _, _, _],
			[_, _, W, W, W, T, T, W, T, _, _, _, _, _, _, _],
			[_, W, T, W, T, T, T, W, T, T, T, _, _, _, _, _],
			[_, W, T, W, W, T, T, T, W, T, T, T, _, _, _, _],
			[_, W, W, T, T, T, T, W, W, W, W, _, _, _, _, _],
			[_, _, _, T, T, T, T, T, T, T, _, _, _, _, _, _],
			[_, _, B, B, R, B, B, B, _, _, _, _, _, _, _, _],
			[_, B, B, B, R, B, B, B, B, B, _, _, _, _, _, _],
			[B, B, B, B, R, R, B, B, B, B, B, _, _, _, _, _],
			[T, T, B, R, Y, R, R, Y, B, T, T, _, _, _, _, _],
			[T, T, T, R, R, R, R, R, T, T, T, _, _, _, _, _],
			[T, T, R, R, R, R, R, R, R, T, T, _, _, _, _, _],
			[_, _, _, _, R, R, R, R, _, _, _, _, _, _, _, _],
			[_, _, _, _, W, W, W, W, W, _, _, _, _, _, _, _],
			[_, _, _, _, _, W, W, W, W, W, _, _, _, _, _, _],
		];

		const marioFBump = [
			[_, _, _, _, R, R, R, R, R, _, _, _, _, _, _, _],
			[_, _, _, R, R, R, R, R, R, R, R, R, _, _, _, _],
			[_, _, _, W, W, W, T, T, W, T, _, _, _, _, _, _],
			[_, _, W, T, W, T, T, T, W, T, T, T, _, _, _, _],
			[_, _, W, T, W, W, T, T, T, W, T, T, _, _, _, _],
			[_, _, W, W, T, T, T, T, W, W, W, W, _, _, _, _],
			[_, _, _, _, T, T, T, T, T, T, T, _, _, _, _, _],
			[_, B, _, _, B, B, R, B, B, B, _, _, B, _, _, _],
			[B, B, B, B, B, R, B, B, B, B, B, B, B, _, _, _],
			[B, B, B, B, R, R, B, B, B, B, B, _, _, _, _, _],
			[T, T, B, R, Y, R, R, Y, B, T, T, _, _, _, _, _],
			[T, T, T, R, R, R, R, R, T, T, T, _, _, _, _, _],
			[T, T, R, R, R, R, R, R, R, T, T, _, _, _, _, _],
			[_, _, R, R, R, _, _, R, R, R, _, _, _, _, _, _],
			[_, W, W, W, _, _, _, W, W, W, _, _, _, _, _, _],
			[W, W, W, W, _, _, W, W, W, W, _, _, _, _, _, _],
		];

		const coinSprite = [
			[_, Y, Y, Y, Y, Y, _, _],
			[Y, Y, W, Y, Y, Y, Y, _],
			[Y, W, Y, Y, Y, Y, Y, _],
			[Y, W, Y, Y, Y, Y, Y, _],
			[Y, W, Y, Y, Y, Y, Y, _],
			[Y, Y, W, Y, Y, Y, Y, _],
			[_, Y, Y, Y, Y, Y, _, _],
			[_, _, _, _, _, _, _, _],
		];

		function drawSprite(ctx: CanvasRenderingContext2D, sprite: Array<Array<string | number | null>>, x: number, y: number, scale: number, flipH: boolean) {
			const rows = sprite.length,
				cols = sprite[0].length;
			for (let r = 0; r < rows; r++) {
				for (let c = 0; c < cols; c++) {
					const color = sprite[r][c] as string;
					if (!color) continue;
					const px = flipH ? x + (cols - 1 - c) * scale : x + c * scale;
					const py = y + r * scale;
					ctx.fillStyle = color;
					ctx.fillRect(px, py, scale, scale);
				}
			}
		}

		// State
		let phase: string, marioX: number, marioY: number, marioVX: number, marioVY: number;
		let frameIdx: number, frameTick: number;
		let groundY: number; // marioY when standing on ground
		let hitY: number; // marioY at peak of bump (bottom of head hits ceiling)
		let coinY: number, coinVY: number, coinVisible: boolean;
		let running = false;

		function initMario() {
			const H2 = mc.height;
			groundY = H2 * 0.46; // mario feet level
			hitY = groundY - 22; // how high he jumps (bump peak)
			marioX = -20 * S;
			marioY = groundY;
			marioVX = 3.2;
			marioVY = 0;
			phase = "enter"; // enter → bump_up → bump_down → exit
			frameIdx = 0;
			frameTick = 0;
			coinVisible = false;
			coinY = groundY - 32 * S; // coin appears well above mario
			coinVY = 0;
			running = true;
		}

		// trigger point: center of screen
		function triggerX() {
			return mc.width / 2 - 6 * S;
		}

		function marioStep() {
			if (!running) return;

			const W2 = mc.width,
				H2 = mc.height;
			mctx.clearRect(0, 0, W2, H2);

			// coin physics
			if (coinVisible) {
				coinY += coinVY;
				coinVY += 0.4;
				drawSprite(mctx, coinSprite, mc.width / 2 - 3 * S, coinY, S, false);
				if (coinY > H2 + 16 * S) coinVisible = false;
			}

			// frame cycling (only while running)
			if (phase === "enter" || phase === "exit") {
				frameTick++;
				if (frameTick >= 6) {
					frameTick = 0;
					frameIdx = (frameIdx + 1) % 3;
				}
			}

			const runFrames = [marioF0, marioF1, marioF2];

			if (phase === "enter") {
				marioX += marioVX;
				drawSprite(mctx, runFrames[frameIdx], marioX, marioY, S, false);
				// reached trigger point → start jump
				if (marioX + 5 * S >= triggerX()) {
					phase = "bump_up";
					marioVX = 0;
					marioVY = -7; // jump velocity upward
				}
			} else if (phase === "bump_up") {
				marioVY += 0.7; // gravity
				marioY += marioVY;
				drawSprite(mctx, marioFBump, marioX, marioY, S, false);
				// reached peak → reverse & spawn coin
				if (marioVY >= 0) {
					phase = "bump_down";
					coinVisible = true;
					coinVY = -10;
					coinY = marioY - 10 * S;
				}
			} else if (phase === "bump_down") {
				marioVY += 0.7;
				marioY += marioVY;
				drawSprite(mctx, marioFBump, marioX, marioY, S, false);
				// landed
				if (marioY >= groundY) {
					marioY = groundY;
					marioVY = 0;
					marioVX = -3.2; // run left
					phase = "exit";
				}
			} else if (phase === "exit") {
				marioX += marioVX;
				drawSprite(mctx, runFrames[frameIdx], marioX, marioY, S, true); // flipped
				if (marioX < -20 * S) {
					running = false;
					setTimeout(() => {
						initMario();
						marioStep();
					}, 2500);
					return;
				}
			}

			requestAnimationFrame(marioStep);
		}

		setTimeout(() => {
			initMario();
			marioStep();
		}, 1200);
	},
	unmounted(mc) {
		window.removeEventListener("resize", mc._resize);
	},
};
